import React from 'react'
import { Box, useTheme, Button, Typography, Stack } from "@mui/material";
import { tokens } from "../../../assets/theme";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "./messages";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

export default function AlarmBanner(props) {
    const { alarms } = props;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();

    function isLight(color) {
        if (color.length === 7) {
            const rgb = [
                parseInt(color.substring(1, 3), 16),
                parseInt(color.substring(3, 5), 16),
                parseInt(color.substring(5), 16),
            ];
            const luminance =
                (0.2126 * rgb[0]) / 255 +
                (0.7152 * rgb[1]) / 255 +
                (0.0722 * rgb[2]) / 255;
            return luminance > 0.5;
        }
        return false
    }

    function getAlarmDescription(readingThresholdId) {
        let alarma = props.readingTypesResult?.data?.find((x) => x.readingThresholds.find(y => y.id === readingThresholdId));
        let name = alarma?.name;
        let type = alarma?.readingThresholds.find(y => y.id === readingThresholdId).type;
        let typeDesc = type === 1 ? formatMessage(messages.high) : formatMessage(messages.low);
        return alarma ? name + " (" + typeDesc + ")" : "?";
    }

     return (
        <Box
            sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                marginTop: "2px",
                marginBottom: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
                direction: "row",
                backgroundColor: props.statusId === 1 ? "#FF6F00" : "#1565C0",
            }}
        >
            <Stack spacing={1} direction="row" sx={{}} display="flex" alignItems="center">
                <NotificationsActiveIcon sx={{ color: "#fff", fontSize: 20 }} />
                <Typography
                    variant="inherit"
                    sx={{ fontSize: '18px', marginLeft: '20px' }}
                >
                    { props.statusId === 2 ? <FormattedMessage {...messages.pausedalarm} /> : <FormattedMessage {...messages.alarm} />}
                </Typography>

                <Box width="20px"></Box>

                {alarms.map((alarma, index) => (
                    <Typography
                        variant="inherit"
                        sx={{ fontSize: '14px', marginLeft: '7px' }}
                    >
                        {getAlarmDescription(alarma.triggeredFromThresholdId)}
                        {/* {alarm.title} */}
                        <span style={{ display: index < alarms.length - 1 ? "inline" : "none" }}>,</span>
                    </Typography>
                ))}
            </Stack>
        </Box>
    )
}